import {
  Button,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
  TextField,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { LocalizationProvider, MobileDatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import moment from "moment";
import React, { useContext, useState } from "react";
import { FailurePop, SuccessPop } from "../../Components/Popup";
import { useDispatch, useSelector } from "react-redux";
import { AppContext } from "../../Components/context/app.context";

const UserInfoPop = ({ detailPop, setDetailPop, setOpenSignin }) => {
  const dispatch = useDispatch();
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const { getUserData } = useContext(AppContext);
  const currentDate = new Date();
  const eighteenYearsAgoDate = new Date(
    currentDate.setFullYear(currentDate.getFullYear() - 18)
  );
  const lastNum = useSelector((data) => data.lastNumber);
  //useState
  const [mail, setMail] = useState("");
  const [name, setName] = useState("");
  const [mobile, setMobile] = useState(lastNum || "");
  const [gender, setGender] = useState("");
  const [dob, setDob] = useState(null);
  const [age, setAge] = useState(0);
  const [referralCode, setReferralCode] = useState("");
  const [onErr, setOnErr] = useState("");
  const [isErr, setIsErr] = useState(false);

  const [modalSuccess, setModalSuccess] = useState(false);
  const [modalFail, setModalFail] = useState(false);
  const [content, setContent] = useState("");
  const [mailValid, setMailValid] = useState(false);
  const [mobileValid, setMobileValid] = useState(false);
  const [validate, setValidate] = useState([
    { name: false, mobile: false, mail: false },
  ]);
  const [loading, setLoading] = useState(false);

  const MailValidate = (val) => {
    if (val.match(/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/)) {
      setMailValid(false);
    } else {
      setMailValid(true);
    }
    if (val.length === 0) {
      setMailValid(false);
    }
  };

  const MobileValidate = (val) => {
    if (val.length === 10) {
      setMobileValid(false);
    } else {
      setMobileValid(true);
    }
    if (val.length === 0) {
      setMobileValid(false);
    }
  };

  const handleMobile = async (e) => {
    const onlyNums = e.target.value.replace(/[^0-9]/g, "");
    if (onlyNums.length < 11) {
      setMobile(onlyNums);
    }
  };

  const ageValidate = async (dob) => {
    var a = moment();
    var b = moment(dob?.$d ? dob?.$d : dob, "MM-YYYY");
    var age = moment.duration(a.diff(b));
    setAge(age?._data?.years);
  };

  const validateForm = async () => {
    if (!mobile || mobile.length != 10) {
      setValidate((validate) => ({ ...validate, mobile: true }));
    } else {
      setValidate((validate) => ({ ...validate, mobile: false }));
    }
    if (!name) {
      setValidate((validate) => ({ ...validate, name: true }));
    } else {
      setValidate((validate) => ({ ...validate, name: false }));
    }
    if (mail && mailValid) {
      setValidate((validate) => ({ ...validate, mail: true }));
    } else {
      setValidate((validate) => ({ ...validate, mail: false }));
    }

    if (!gender) {
      setValidate((validate) => ({ ...validate, gender: true }));
    } else {
      setValidate((validate) => ({ ...validate, gender: false }));
    }

    if (
      !name ||
      !mobile ||
      mobile.length != 10 ||
      (mail && mailValid) ||
      !gender
    ) {
      setContent("Please Provide Required Details");
      setModalFail(true);
      setTimeout(() => {
        setModalFail(false);
      }, 1500);
    } else {
      if (age < 18) {
        setContent("DOB Required & Age should be above 18");
        setModalFail(true);
        setTimeout(() => {
          setModalFail(false);
        }, 1500);
        return true;
      }

      updateProfile();
    }
  };

  const updateProfile = async () => {
    setLoading(true);
    try {
      let data = {
        name: name,
        email: mail,
        last_name: "",
        mobile: mobile,
        dob: dob ? moment(dob?.$d).format("YYYY-MM-DD") : "",
        gender: gender,
        referralCode: referralCode,
      };
      const response = await global.$axios.post("customer/profileUpdate", data);
      console.log("response", response.data);
      if (response.data.status === "success") {
        setContent("Success");
        getUserData();
        getUpdatedUser();
        setModalSuccess(true);
        setTimeout(() => {
          setModalSuccess(false);
        }, 1500);
        setLoading(false);
      } else {
        setContent("Something Went Wrong,..Try Again");
        setModalFail(true);
        setTimeout(() => {
          setModalFail(false);
        }, 1500);
        setLoading(false);
      }
    } catch (error) {
      console.log("Update Profile", error);
      setLoading(false);
    }
  };

  const handleReferral = async (val) => {
    setReferralCode(val);
    setIsErr(false);
    try {
      const response = await global.$axios.post(
        `customer/checkValidReffralCode`,
        {
          referralCode: val,
        }
      );
      console.log("handleReferal", response.data);
      if (response.data.status === "success") {
        setIsErr(false);
        let data = response.data;
        setOnErr(data);
      } else {
        let data = response.data;

        setOnErr(data);
        setIsErr(true);
      }
    } catch (error) {
      console.log("handleReferal", error);
    }
  };

  const getUpdatedUser = async () => {
    try {
      const response = await global.$axios.get(
        `customer/customerData/${global.$userData.id}`
      );
      if (response.data.status == "success") {
        dispatch({
          type: "SET_USER_IN",
          data: { ...response.data, ...{ reload: false } },
          payload: true,
        });
        setOpenSignin(false);
        setDetailPop(false);
      } else {
        setContent("Something Went Wrong., Try Again");
        setModalFail(true);
        setTimeout(() => {
          setModalFail(false);
        }, 1500);
      }
    } catch (error) {
      console.log("Updated User Issue", error);
    }
  };
  return (
    <div>
      <Dialog
        fullScreen={fullScreen}
        fullWidth={true}
        maxWidth={"sm"}
        open={detailPop}
        aria-labelledby="draggable-dialog-title"
      >
        <Grid sx={{ py: 2, px: 1 }}>
          <DialogTitle>
            <Typography sx={{ color: "#071CB7", fontWeight: 600 }}>
              Personal Details
            </Typography>
          </DialogTitle>

          <DialogContent sx={{ px: { sm: 3, xs: 0 } }}>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: 10,
                marginTop: "20px",
              }}
            >
              <Grid item lg={8} md={9} xs={12} style={{ mx: 3 }}>
                <Typography sx={{ fontSize: "12px" }}>
                  Name<span style={{ color: "red" }}>*</span>
                </Typography>
                <TextField
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  required
                  placeholder="Your Name Here"
                  size="small"
                  fullWidth
                  sx={{
                    mt: 0.5,
                  }}
                  error={validate.name}
                />
              </Grid>

              <Grid item lg={8} md={9} xs={12} style={{ mx: 3 }}>
                <Typography sx={{ fontSize: "12px" }}>
                  Mobile Number<span style={{ color: "red" }}>*</span>
                </Typography>
                <TextField
                  value={mobile}
                  onChange={(e) => {
                    MobileValidate(e.target.value);
                    handleMobile(e);
                  }}
                  error={validate.mobile}
                  placeholder="Your Mobile Number Here"
                  size="small"
                  fullWidth
                  disabled
                  label={mobileValid ? "10 Digits Required" : ""}
                  inputProps={{
                    maxLength: 10,
                    //   inputMode: "numeric",
                    pattern: "^[0-9]*$",
                  }}
                  sx={{
                    borderRadius: 1,
                    mt: 0.5,
                    ".MuiInputLabel-root": { color: "red" },
                  }}
                />
              </Grid>

              <Grid item lg={8} md={9} xs={12} style={{ mx: 3 }}>
                <Typography sx={{ fontSize: "12px" }}>Email</Typography>
                <TextField
                  value={mail}
                  onChange={(e) => {
                    MailValidate(e.target.value);
                    setMail(e.target.value);
                  }}
                  error={validate.mail}
                  label={validate.mail ? "Invalid Mail" : ""}
                  placeholder="Your Email Here"
                  size="small"
                  fullWidth
                  sx={{
                    borderRadius: 1,
                    mt: 0.5,
                    ".MuiInputLabel-root": { color: "red" },
                  }}
                />
              </Grid>

              <Grid item lg={8} md={9} xs={12} style={{ mx: 3 }}>
                <Typography sx={{ fontSize: "12px" }}>Referral Code</Typography>
                <TextField
                  value={referralCode}
                  onChange={(e) => {
                    handleReferral(e.target.value);
                  }}
                  error={validate.mail}
                  label={validate.mail ? "Invalid Mail" : ""}
                  placeholder="Referral Code(Optional)"
                  size="small"
                  fullWidth
                  sx={{
                    borderRadius: 1,
                    mt: 0.5,
                    ".MuiInputLabel-root": { color: "red" },
                  }}
                />
                {referralCode.length > 4 && (
                  <div
                    style={{
                      color: isErr ? "red" : "green",
                      fontSize: 10,
                    }}
                  >
                    {onErr?.message}
                  </div>
                )}
              </Grid>

              <Grid item md={5} sm={6} xs={12} sx={{ mb: 1 }}>
                <Typography sx={{}}>
                  DOB<span style={{ color: "red" }}>*</span>
                </Typography>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <MobileDatePicker
                    placeholder="DD/MM/YYYY"
                    value={dob}
                    maxDate={dayjs(eighteenYearsAgoDate)}
                    slotProps={{
                      textField: {
                        size: "small",
                        error: age < 18,
                      },
                    }}
                    onChange={(newValue) => {
                      ageValidate(newValue);
                      setDob(newValue);
                    }}
                    format="LL"
                  />
                </LocalizationProvider>
              </Grid>

              <Typography sx={{ mt: 2 }}>
                Gender<span style={{ color: "red" }}>*</span>
              </Typography>
              <Grid container item sx={{ display: "flex" }}>
                <RadioGroup
                  defaultValue=""
                  row
                  value={gender}
                  onChange={(e) => setGender(e.target.value)}
                >
                  <FormControlLabel
                    value="Male"
                    control={
                      <Radio
                        sx={{
                          color: "#000",
                          "&.Mui-checked": { color: "#071CB7" },
                        }}
                      />
                    }
                    label="Male"
                  />
                  <FormControlLabel
                    value="Female"
                    control={
                      <Radio
                        sx={{
                          color: "#000",
                          "&.Mui-checked": { color: "#071CB7" },
                        }}
                      />
                    }
                    label="Female"
                  />
                </RadioGroup>
              </Grid>

              <Grid item lg={8} md={9} xs={12} sx={{ mt: 3 }}>
                <Button
                  size="large"
                  contained
                  color="primary"
                  disabled={loading}
                  fullWidth
                  sx={{ textTransform: "capitalize" }}
                  style={{ background: "#0A2FB6", color: "#FFF" }}
                  onClick={() => {
                    validateForm();
                  }}
                >
                  {loading ? (
                    <CircularProgress
                      size={26}
                      thickness={3}
                      sx={{ color: "#FFF" }}
                    />
                  ) : (
                    "Submit"
                  )}
                </Button>
              </Grid>
            </div>
          </DialogContent>
        </Grid>
      </Dialog>
      {modalSuccess && (
        <SuccessPop
          modalSuccess={modalSuccess}
          setModalSuccess={setModalSuccess}
          content={content}
        />
      )}
      {modalFail && (
        <FailurePop
          modalFail={modalFail}
          setModalFail={setModalFail}
          content={content}
        />
      )}
    </div>
  );
};

export default UserInfoPop;
